import Vue from 'vue'
import Vuex from 'vuex'
import * as Sentry from '@sentry/browser'
import ApiClient from '@/components/api-client.js'
import brand from './modules/brand'
import organize from './modules/organize'
import measure from './modules/measure'
import assetDetail  from './modules/assetDetail'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    demo: false,
    user: {
      isAnonymous: true,
      acceptedPrivacyPolicy: false,
      email: null,
      firstName: null,
      lastName: null,
      id: null,
      isGdprCovered: false,
      isImpersonated: null,
      roles: [],
      settings: {}
    },
    // For now theme will only be changed for the silverado campaign. However, we can store this with user
    // preferences if we want to offewr themes ion the future.
    theme: 'normal'
  },
  mutations: {
    setDemo (state, value) {
      state.demo = value
      window.localStorage.setItem('demo', value)
    },
    setUser (state, user) {
      state.user = user
      if (user.isAnonymous) {
        Sentry.configureScope(scope => {
          scope.setUser({})
        })
      } else {
        Sentry.configureScope(scope => {
          scope.setUser({
            'First Name': user.firstName,
            'Last Name': user.lastName,
            email: user.email,
            id: user.id
          })
        })
      }
    },
    setTheme (state, v) {
      state.theme = v
    }
  },
  actions: {
    loadUser ({commit, state}, forceLoad) {
      if (!state.user.isAnonymous && !forceLoad) {
        return Promise.resolve(state.user)
      }

      return ApiClient.currentUser()
        .then(
          response => {
            commit('setUser', response.data)
            return state.user
          }
        )
    },
    logOutUser ({commit}) {
      window.localStorage.removeItem('token')
      commit('setUser', {isAnonymous: true})
    }
  },
  getters: {
    getUser: state => {
      return state.user
    }
  },
  modules: {
    brand: brand,
    organize,
    measure,
    assetDetail
  }
})

export default store
